import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { AttachmentType, Editor2Attachment, ShopProductInfo } from 'src/app/shared/models/misc.model';
import { BasicService } from '../../services/basic.service';
import { MediasService } from '../../services/medias.service';
import { UploadService } from '../../services/upload.service';
import { AgentShortcut } from '../agent-shortcuts-modal/agent-shortcut.model';
import { PictureModalComponent } from '../picture-modal/picture-modal.component';

@Component({
  selector: 'app-attachment-thumbnail',
  templateUrl: './attachment-thumbnail.component.html',
  styleUrls: ['./attachment-thumbnail.component.scss'],
})
export class AttachmentThumbnailComponent {
  AttachmentType = AttachmentType;

  type: string;
  pictureUrl?: string;
  gifUrl?: string;
  videoUrl?: string;
  audioUrl?: string;
  fileName?: string;
  fileUrl?: string;
  title?: string;
  url?: string;
  linkLabel?: string;
  linkTarget?: string;
  shopProduct?: ShopProductInfo;
  agentShortcut?: Partial<AgentShortcut>;
  isValid?: boolean;

  showVideo = false;

  @Input() canBeRemoved = false; // optional; should be true in the answer editor
  @Output() removedClicked = new EventEmitter<void>();
  @Output() copyAttachmentText = new EventEmitter<void>();

  @HostBinding('class.no-wrap') noWrap = false;

  constructor(
    private basicService: BasicService,
    private mediasService: MediasService,
    private uploadService: UploadService
  ) {}

  @Input() set attachment(attachment: Editor2Attachment) {
    if (attachment) {
      this.type = attachment.type;
      this.isValid = attachment.isValid;
      const { value } = attachment;

      switch (this.type) {
        case AttachmentType.Picture:
          this.pictureUrl = value.pictureId
            ? this.uploadService.pictureUrl(value.pictureId)
            : value.messageAttachementURL;
          break;
        case AttachmentType.Video:
          this.videoUrl = value.videoId ? this.uploadService.videoUrl(value.videoId) : value.messageAttachementURL;
          break;
        case AttachmentType.Audio:
          // Audio attachments are present in tasks only (advisers can't add audio in the answer editor)
          this.audioUrl = value.messageAttachementURL;
          break;
        case AttachmentType.File:
          this.fileName = value.fileName;
          this.fileUrl = value.fileId ? this.uploadService.fileUrl(value.fileId) : value.messageAttachementURL;
          if (this.seemsLikeAnImage(this.fileName)) {
            this.type = AttachmentType.Picture;
            this.pictureUrl = this.fileUrl;
          }
          break;
        case AttachmentType.Link:
          this.linkLabel = value.linkLabel;
          this.linkTarget = value.linkTarget;
          this.noWrap = true;
          break;
        case AttachmentType.BZCRichLink:
        case AttachmentType.BZCSplittableRichLink:
          this.title = value.title;
          this.url = value.url;
          break;
        case AttachmentType.ShopProduct:
          this.shopProduct = value;
          this.pictureUrl = this.shopProduct.imageUrl;
          break;
        case AttachmentType.AgentShortcut:
          this.agentShortcut = value;
          break;
      }
    }
  }

  onPictureClicked() {
    this.basicService.modal({
      component: PictureModalComponent,
      componentProps: {
        src: this.pictureUrl,
      },
    });
  }

  onRemoveClicked() {
    this.removedClicked.emit();
  }

  onModifyClicked() {
    this.copyAttachmentText.emit();
  }

  downloadFile() {
    this.mediasService.downloadFile(this.fileUrl, this.fileName);
  }

  private seemsLikeAnImage(fileName) {
    return typeof fileName === 'string' && fileName.toLowerCase().match(/\.png$|\.gif$|\.jpg$|\.jpeg$/);
  }
}
